import { baseRequest } from "./base-request";
// import { presendMockData } from './mock';
// import { mockCouponHistryList } from './mock/coupon-list-mock'
export const HOST = {
    test: 'https://api.hotel.test.sankuai.com',
    prod: 'https://apihotel.meituan.com'
};
const hostUrl = HOST.prod;
export const presendCoupon = async (params, baseParams) => {
    const url = `${hostUrl}/api/altas/marketing/activity/query/info`;
    // return presendMockData.data;
    return baseRequest({
        url,
        method: 'POST'
    }, baseParams, params);
};
export const sendCoupon = async (params, baseParams) => {
    const url = `${hostUrl}/api/altas/marketing/activity/draw/prize`;
    // return {
    //   "userPrizeInfos": [
    //     {
    //       "uuid": null,
    //       "prizeBatchId": "1713774083",
    //       "rewardId": null,
    //       "rewardType": null,
    //       "prizeCode": null,
    //       "prizeName": null,
    //       "bizLine": null,
    //       "amount": null,
    //       "amountType": null,
    //       "requireAmount": null,
    //       "prizeDesc": null,
    //       "prizeStatus": 7,
    //       "cannotDrawCode": null,
    //       "cannotDrawReason": "领券成功",
    //       "jumpUrl": "imeituan://www.meituan.com/traffic/homepage?trafficsource=_bhomecateall&type=0&default=-1",
    //       "expireDesc": null,
    //       "expireTime": 1770618035000,
    //       "drawTime": null,
    //       "drawTimeDesc": null,
    //       "drawEndTime": null,
    //       "personaDesc": null,
    //       "maxDiscountAmount": null,
    //       "showStatus": null
    //     }
    //   ]
    // }
    return baseRequest({
        url,
        method: 'POST'
    }, baseParams, params);
};
export const getVerifyUrl = async (baseParams) => {
    return baseRequest({
        url: `${hostUrl}/api/altas/risk/realName/createCertifyUrl`,
        method: 'POST'
    }, baseParams, {});
};
export const getHistoryPrize = async (params, baseParams) => {
    const url = `${hostUrl}/api/altas/marketing/activity/query/historyPrize`;
    // return mockCouponHistryList;
    return baseRequest({
        url,
        method: 'POST'
    }, baseParams, params);
};
